import React from 'react';
import { Form, Select } from 'antd';
import Layout from './layout';

const FormItem = Form.Item;
const Option = Select.Option;

const defaultRules = [
  {
    required: true,
    message: '\u8bfe\u7a0b\u4e0d\u80fd\u4e3a\u7a7a',
  },
];

const CourseFormItem = (props) => {
  const { fetchCoursesList, courseList, itemStyle, form } = props;
  const label = props.label || '\u8bfe\u7a0b';
  const fieldName = props.fieldName || 'course';
  const valueField = props.valueField || '_id';
  const layouts = props.formItemLayout
    ? props.formItemLayout
    : Layout.formItemLayout;
  const rules = props.rules ? props.rules : defaultRules;

  const courses = courseList.sort((a, b) => {
    const aWeight = typeof a.weight === 'number' ? a.weight : Number(a.code);
    const bWeight = typeof b.weight === 'number' ? b.weight : Number(b.code);
    return aWeight - bWeight;
  });

  return (
    <FormItem label={label} {...layouts} name={fieldName} rules={rules} form={form}>
      <Select
        mode='single'
        showSearch
        optionFilterProp='children'
        filterOption={(input, option) =>
          String(option.children).toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onFocus={fetchCoursesList}
        style={itemStyle}
        allowClear
      >
        {courses.map((item) => {
          const value = item[valueField] || item._id;
          return (
            <Option value={value} key={item._id}>
              {item.name}
            </Option>
          );
        })}
      </Select>
    </FormItem>
  );
};

export default CourseFormItem;
